import "./Security.scss";
import check from "../../assets/check2.png";
import security from "../../assets/securityimg.png";
import securitymobile from "../../assets/securitymobile.png";

export default function Security() {
  return (
    <div className="security spacing">
      <div className="contentmain">
        <div className="left">
          <h2>Your Payments. Fully Protected.</h2>
          <p>
            You focus on scaling—we’ll handle the security behind every
            transaction.
          </p>
        </div>
        <div className="right">
          <img src={security} alt="error" className="desktopimg"/>
          <img src={securitymobile} alt="error" className="mobileimg"/>
        </div>
      </div>
    </div>
  );
}
